import { connect } from "react-redux"
import React, { Component } from 'react';
import './Common.css';
import './MenuBar.css';
import { navigate, updateLoginStatus, showProfileMenu } from "../actions/betActions"
import logoImage from "../atstakelogo.png";
//import logoImage from "../logo2.svg";
const stateMap = (store) => {
    return {
      selectedPage: store.bet.selectedPage,
      loggedIn: store.bet.authentication.loggedIn,
      pageLoaded: store.bet.pageLoaded,
      authentication: store.bet.authentication,
      ethAccount: store.bet.authentication.ethAccount,
      showProfileMenu: store.bet.showProfileMenu
    };
};
class MenuBar extends Component {
    constructor(props) {
      super(props);

        // This binding is necessary to make `this` work in the callback
        this.navigate = this.navigate.bind(this);
        this.logIn = this.logIn.bind(this);
        this.logOut = this.logOut.bind(this);
        this.toggleProfileMenu = this.toggleProfileMenu.bind(this);
        this.handleOutsideClick = this.handleOutsideClick.bind(this);
        this.node = null;
    }
  
    componentDidMount() {
    }

    componentWillUnmount() {
    }

    componentWillReceiveProps(nextProps) {
      if (nextProps.showProfileMenu !== this.props.showProfileMenu) {
        if(nextProps.showProfileMenu) {
          document.addEventListener('mousedown', this.handleOutsideClick, false);
        }
        else {
          document.removeEventListener('mousedown', this.handleOutsideClick, false);
        }
      }
    }

    handleOutsideClick(event) {
        if(this.node.contains(event.target)) {
            return;
        }

        if(this.props.showProfileMenu) {
          this.toggleProfileMenu(event);
        }
    }

    navigate(event) {
        this.props.dispatch(navigate(event.target.getAttribute("name"), this.props.authentication));
    }

    logIn(event) {
      this.props.dispatch(updateLoginStatus(true));
      this.props.dispatch(showProfileMenu(false));
    }

    logOut(event) {
      this.props.dispatch(updateLoginStatus(false));
      this.props.dispatch(showProfileMenu(false));
    }

    toggleProfileMenu(event) {
      this.props.dispatch(showProfileMenu(!this.props.showProfileMenu));
    }
  
    render() {  

      let selectedPage = "SUMMARY";
      let loggedIn = this.props.loggedIn;
      let pageLoaded = this.props.pageLoaded;
      let { showAuthFlow=false, username="" } = this.props.authentication;

      if(!loggedIn) {
        selectedPage = "SPLASH"
      }
      else if(this.props.selectedPage === "LIST_BETS" || this.props.selectedPage === "PROPOSE_BET" || this.props.selectedPage === "VIEW_PROPOSAL" || this.props.selectedPage === "LINK_ACCOUNT" || this.props.selectedPage === "BROWSE_BETS" || this.props.selectedPage === "NEW_BET" || this.props.selectedPage === "VIEW_BET" || this.props.selectedPage === "LINK_TWITTER" || this.props.selectedPage === "HELP" || this.props.selectedPage === "SPLASH") {
        selectedPage = this.props.selectedPage;
      }

      return (
        <div>
          <div className="menuBar">
            <div className="menuInner">
              <span className="logoSpan"><a style={{textDecoration:"none"}} href="/"><img className="logoImg" src={logoImage} alt="Ethbet" /></a></span>
              {!pageLoaded ? (<span className="menuBtn">&nbsp;</span>) : loggedIn ? (
                <span>
                  <span name="SUMMARY" onClick={this.navigate} className={"menuBtn" + (selectedPage === "SUMMARY" ? " selectedBtn": "")}>My bets</span>
                  <span name="PROPOSE_BET" onClick={this.navigate} className={"menuBtn" + (selectedPage === "PROPOSE_BET" ? " selectedBtn": "")}>Propose bet</span>
                  <span name="BROWSE_BETS" onClick={this.navigate} className={"menuBtn" + (selectedPage === "BROWSE_BETS" ? " selectedBtn": "")}>Browse bets</span>
                  <span name="HELP" onClick={this.navigate} className={"menuBtn" + (selectedPage === "HELP" ? " selectedBtn": "")}>Help</span>
                  {false ? (<span name="VIEW_BET" onClick={this.navigate} className={"menuBtn" + (selectedPage === "VIEW_BET" ? " selectedBtn": "")}>View bet</span>): ""}
                  {false ? (<span name="VIEW_PROPOSAL" onClick={this.navigate} className={"menuBtn" + (selectedPage === "VIEW_PROPOSAL" ? " selectedBtn": "")}>View proposed bet</span>): ""}
                  {false ? (<span name="LINK_ACCOUNT" onClick={this.navigate} className={"menuBtn" + (selectedPage === "LINK_ACCOUNT" ? " selectedBtn": "")}>Link account</span>): ""}
                  {false ? (<span name="NEW_BET" onClick={this.navigate} className={"menuBtn" + (selectedPage === "NEW_BET" ? " selectedBtn": "")}>Create new bet</span>): ""}
                  {false ? (<span name="LIST_BETS" onClick={this.navigate} className={"menuBtn" + (selectedPage === "LIST_BETS" ? " selectedBtn": "")}>List bets</span>): ""}
                </span>
              ): (
                <span name="SPLASH" onClick={this.navigate} className={"menuBtn" + (selectedPage === "SPLASH" ? " selectedBtn": "")}>Ethbet</span>
              )}
            </div>
            <div className="menuInnerRight">
              {!pageLoaded ? "" : loggedIn ? (
                <span ref={node => this.node = node}><span style={{position:"relative"}}><div style={{display: this.props.showProfileMenu ? "block" : "none"}} onClick={this.logOut} className="profileMenu">Log out</div></span><span onClick={this.toggleProfileMenu} className="menuBtn" name="ACCOUNT">@{username}</span></span>
              ): showAuthFlow ? (
                <button onClick={this.logOut} className="btn btnMenu moveRight15">Cancel log in</button>
              ): (
                <button onClick={this.logIn} className="btn btnMenu moveRight15">Log in</button>
              )}
            </div>
        </div>
        <div className="menuPlaceholder"></div>
       </div>
      );
    }
  }

  export default connect(stateMap)(MenuBar);



// WEBPACK FOOTER //
// ./src/components/MenuBar.js